import axios from "axios"

class ProductFinder {
    constructor() {
        if (document.querySelector(".submit-finder")) {
            this.itemNumberField = document.querySelector("#inputItemNumber")
            this.resultsDiv = document.querySelector("#product-finder-results")

            this.events()
        }
    }

    events() {
        document.querySelector(".submit-finder").addEventListener("click", e => this.findProduct(e))
    }

    // methods
    async findProduct(e) {
        e.preventDefault()
        try {
            const response = await axios.get(hawoData.root_url + "/wp-json/hawo/v1/search?number=" + this.itemNumberField.value)
            const results = response.data
            this.resultsDiv.innerHTML = `
                ${results.length ? "" : '<p class="mb-0 mt-2 text-danger"><strong>No product matches that item number.</strong></p>'}
                ${results.map(item => `<p class="mb-0 mt-2 text-success"><strong>Your Product:</strong> ${item.title}</p>`).join("")}
            `
        } catch (e) {
            console.log(e)
        }
    }

}

export default ProductFinder
